import { Component } from "@angular/core";
import { NavController, NavParams, ViewController } from "ionic-angular";
import { Validators, FormBuilder, FormGroup } from "@angular/forms";
import { DataProvider } from "../../providers/data/data";
import { DemoProvider } from "../../providers/demo/demo";
import { StarmsClientProvider } from "../../providers/starms-client/starms-client";
import * as moment from "moment";
import { ApplicationApiProvider } from "../../providers/application-api/application-api";
import { EntitiesProvider } from "../../providers/entities/entities";
import { Train } from "../../app/models/Train";

@Component({
  selector: "page-add-form",
  templateUrl: "add-form.html",
})
export class AddFormPage {
  type: string;
  addingInProgress = false;
  trains: Train[] = [];

  addLogForm: FormGroup;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private formBuilder: FormBuilder,
    private dataProvider: DataProvider,
    private global: DemoProvider,
    public entitiesProvider: EntitiesProvider,
    private starms: StarmsClientProvider,
    private appApi: ApplicationApiProvider,
    private viewCtrl: ViewController
  ) {
    this.addLogForm = this.formBuilder.group({
      train: [""],
      description: ["", Validators.required],
      date: ["", Validators.required],
      time: ["", Validators.required],
      hours: [null],
      starts: [null],
    });
  }

  ionViewDidLoad() {
    if (this.entitiesProvider.currentEntity.getType() === "customer") {
      this.trains = this.entitiesProvider.getTrainsByCustomer(
        this.entitiesProvider.currentEntity.getId()
      );
    } else {
      this.trains = [this.entitiesProvider.currentEntity as Train];
    }
  }

  submit(): void {
    this.postLog();
  }

  createLogObject(): any {
    let selTime = moment(this.addLogForm.value.time);
    let formDate = new Date(
      this.addLogForm.value.date + " " + this.addLogForm.value.time
    );
    console.log(
      "🚀 ~ file: add-form.ts ~ line 60 ~ AddFormPage ~ createLogObject ~ formDate",
      formDate
    );
    console.log(
      "🚀 ~ file: add-form.ts ~ line 59 ~ AddFormPage ~ createLogObject ~ this.addLogForm.value",
      this.addLogForm.value
    );

    return {
      TrainId: this.addLogForm.value.train,
      Description: this.addLogForm.value.description,
      SiteTime: formDate,
      PackageHours: this.addLogForm.value.hours,
      PackageStarts: this.addLogForm.value.starts,
    };
  }

  postLog(): void {
    if (this.addLogForm.valid) {
      if (this.global.demoMode) {
        let model = {
          logbookId: 130,
          userId: 0,
          trainId: 0,
          description: "test",
          created: "2018-12-12T09:44:29.0587146+01:00",
          siteTime: "2018-12-11T23:00:00.0000000+01:00",
          packageHours: 3,
          packageStarts: 3,
          actual: false,
        };
        let data = this.createLogObject();
        model.trainId = data.TrainId;
        model.description = data.Description;
        model.created = data.SiteTime;
        model.packageHours = data.PackageHours;
        model.packageStarts = data.packageStarts;
        let temp = this.dataProvider.demoLogBook.getValue();
        temp.push(model);
        this.dataProvider.demoLogBook.next(temp);
        this.appApi.showToast("The log has been added");
      } else {
        this.addingInProgress = true;
        let data = this.createLogObject();
        console.log(
          "🚀 ~ file: add-form.ts ~ line 99 ~ AddFormPage ~ postLog ~ data",
          data
        );
        this.starms.post(["logbook"], undefined, data).subscribe(
          (result) => {
            this.appApi.showToast("The log has been added");

            this.viewCtrl.dismiss({
              refresh: true,
              result: result,
            });
          },
          () => {
            this.handleFormError();
          }
        );
      }
    } else {
      this.handleFormError();
    }
  }

  private handleFormError(): void {
    this.appApi.showToast(
      "Your form has encountered a problem. Please fix it and try again"
    );
  }

  clear(): void {
    this.addLogForm.reset();
  }

  close(): void {
    this.viewCtrl.dismiss({
      refresh: false,
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/add-form/add-form.ts